import { PartnerType, PartnerStructureSubType } from 'types/Partner';
import { PARTNER_ORCHESTRATOR_API_URL } from 'services/constants';
import axios from 'axios';
import { BrType, BrSubType, BrProfileType } from 'types/BrTypes';
import { PartnerLockType } from 'types/PartnerLockTypes';
import { RevisionDetail } from 'views/RevisionHistory/RevisionDtos';
import { getHostBaseUrl } from 'utils/browserUtil';

const axiosInstance = axios.create({ baseURL: getHostBaseUrl(), withCredentials: true });

/**
 * Get the profiling wizard profile (e.g. LE_P6, PI_P2) of a partner
 * @param brType the BR type
 * @param partnerType the type of the partner
 * @param roleType role type
 * @param brSubType the partner type of the partner
 * @param partnerStructureSubType Type of business relationship sub type.
 * @param operationalType Partner operational type.
 * @param brProfile Business relationship profile.
 */
export const getPartnerProfile = async (
  brType: BrType,
  roleType: string,
  partnerType: PartnerType,
  partnerStructureSubType?: PartnerStructureSubType,
  brSubType?: BrSubType,
  operationalType?: string,
  brProfile?: BrProfileType,
) => {
  const baseParams = {
    roleType,
    partnerType: partnerType,
    businessRelationshipType: brType,
  };

  const conditionalParams = {
    ...(brSubType && { businessRelationshipSubType: brSubType }),
    ...(partnerStructureSubType && { partnerStructureSubType }),
    ...(operationalType && { operationalType }),
    ...(brProfile && { brProfile }),
  };

  const queryParams = new URLSearchParams({
    ...baseParams,
    ...conditionalParams,
  }).toString();

  const { data } = await axiosInstance.get(
    `${PARTNER_ORCHESTRATOR_API_URL}/api/static/intended-roles/profile?${queryParams}`,
  );
  return data;
};

export const getPartnerLockStatus = async (partnerUid: string): Promise<PartnerLockType[]> => {
  const { data } = await axiosInstance.get(`${PARTNER_ORCHESTRATOR_API_URL}/api/partners/${partnerUid}/lock`);
  return data as PartnerLockType[];
};

export const getPartnerVersion = async (partnerUid: string) => {
  const { data } = await axiosInstance.get(`${PARTNER_ORCHESTRATOR_API_URL}/api/partners/${partnerUid}/versions`);
  return data;
};

export const getPartnerComparison = async (
  partnerUid: string,
  oldVersion: number | null,
  newVersion: number | null,
): Promise<RevisionDetail[]> => {
  const { data } = await axiosInstance.get(`${PARTNER_ORCHESTRATOR_API_URL}/api/comparison/partners/${partnerUid}`, {
    params: {
      oldVersion,
      newVersion,
    },
  });
  return data as RevisionDetail[];
};

const partnerOrchestratorService = {
  getPartnerProfile,
  getPartnerLockStatus,
  getPartnerVersion,
  getPartnerComparison,
};
export default partnerOrchestratorService;
